<template>
    <b-modal
        footer-class="p-2 border-top-0"
        :id="id"
        :title="title"
        :cancel-title="$t(cancelText)"
        :ok-only="isOkOnly"
        :ok-title="$t(okText)"
        @ok="onOkPressed"
    >
        <b-img :src="img" class="ml-5" fluid alt="Responsive image"></b-img>
    </b-modal>
</template>

<script>

export default {
    name: "Modal",
    props: {
        id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true
        },
        img: {
            type: String,
            required: true,
        },
        onOkPressed: {
            type: Function,
            default: () => {},
        },
        isOkOnly: {
            type: Boolean,
            default: true
        },
        okText: {
            type: String,
            default: 'ok'
        },
        cancelText: {
            type: String,
            default: 'no'
        }
    }
}
</script>

<style scoped>

</style>
